// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3997":"082b82eec4f559b3","8996":"27e79cf2b4f03842"}[chunkId] + ".js";
};